import { DevicePid, KK, kks, VK } from '@/define/define'
import { getDeviceKeySquare, square } from './keyboard/keysquare/keysquare'
import { defaultTexture as defaultTexture } from './keyboard/keytexture/default'
import { al87VKCodes } from './keyboard/keycode/vkeycode'
import { DeviceType } from '@libs/types/enum'
import { LightEffectModeType } from '@/define/light'
import { lightDataByVersion } from './light_limit'
export interface CustomLayout {
  [index: KK]: square
}
export class Dpi {
  initList: number[] = []
  initListColor: number[][] = []
  length: number = 0
  list: number[] = []
  des: string = ''
  isEdit: boolean = false
  isColor: boolean = false
}

export class DebounceTime {
  max: number = 0
  initValue: number = 0
}

export class BaseDevice {
  constructor() {}
  // 宏最大固定延迟
  maxDelayTimer: number = 2000
  // 宏最小固定延迟
  minDelayTimer: number = 0

  // 设备名
  name: string = ''
  // 设备图标
  icon: string = ''
  // 渲染整体宽度
  width: number = 750

  // 渲染背景图
  boardImage: string = ''

  // 渲染内边距
  paddingX: number = 10
  paddingY: number = 10
  paddingBottom: number = 10

  // 设备类型
  deviceType = DeviceType.keyboard
  texture = defaultTexture()

  // 是否是QMK设备
  isQMKDevice = false
  // 鼠标的class
  mouseClass: { [index: KK]: string } = {} // TODO:
  // 是否是磁轴键盘
  magneticAxis: boolean = false // 初始值为false，表示不支持磁轴

  vkcodes: VK[][] = al87VKCodes
  // 特殊按键 例如：fn
  inoperableKeys: KK[] = [0x18]
  // FN 层不可选按键
  fnDisableKeys: KK[] = []
  customLayout: { [index: KK]: square } = {}
  absoluteKey: { [index: KK]: square } = {}
  square: square = getDeviceKeySquare(DevicePid.None)

  /**
   * 获取按键的渲染方格
   */
  getKeySquare(kk: KK): square {
    if (this.absoluteKey[kk]) {
      return this.absoluteKey[kk]
    } else if (this.customLayout[kk]) {
      return this.customLayout[kk]
    } else {
      return this.square
    }
  }

  /**
   * 是否是绝对定位
   */
  isAbsolute(kk: KK): boolean {
    return !!this.absoluteKey[kk]
  }

  /**
   * 获取按键的 class 名称
   */
  getKeyClassName(kk: KK): string {
    if (this.deviceType === DeviceType.mouse) {
      return this.mouseClass[kk] || ''
    }
    return ''
  }

  protected createSquare(x: number = this.square.x, y: number = this.square.y, w: number = this.square.w, h: number = this.square.h): square {
    return { x, y, w, h }
  }
  getKeyDataAndLayout = (): Map<KK, VK>[] => {
    const result: Map<KK, VK>[] = []
    const vkcodes = this.vkcodes.length > 0 ? this.vkcodes : al87VKCodes

    vkcodes.forEach((line) => {
      const map = new Map<KK, VK>()
      line.forEach((value) => {
        const kk = Object.entries(kks.value).find(([_, v]) => v === value)?.[0]
        if (kk !== undefined) {
          map.set(Number(kk), value)
        }
      })
      if (map.size > 0) result.push(map)
    })
    return result
  }

  protected lightEffectList: { [name: LightEffectModeType]: number } = {}

  // 由于是根据固件版本获取的，所以需要异步，等待固件版本获取到之后，在返回相应数据
  getLightEffectList = async (): Promise<{ [name: LightEffectModeType]: number }> => {
    return await lightDataByVersion(this.lightEffectList)
  }

  speedAllowValues: number[] = [0, 1, 2, 3, 4]
  lightAllowValues: number[] = [0, 1, 2, 3, 4]
  dpi: Dpi = new Dpi()

  // win按键锁定
  lockWin: boolean = false

  // 超级响应模式
  superResponse: boolean = false

  // 休眠模式
  sleepTimeValues: number[] = []

  // 蓝牙休眠模式
  sleepTimeBTValues: number[] = []

  //回报率
  rate: number[] = []

  // 重置des
  resetDes: string = 'recovery_notice'
  brushFirmwareUrl = ''

  // 说明书的id
  manualId: number = 0

  // 防误触模式 -> 去抖
  touchGuard: boolean = false

  // 调整RT增稳算法
  adjustRTStabilization: number[] = []

  debounceTime: DebounceTime = new DebounceTime()
  // 高性能模式
  highPerformanceValues: number[] = []

  // 键盘防抖
  keyboardDebounce: number[] = []

  // 可设置的磁轴按键
  configurableMagneticAxis: number[] = []
}

//Value--dpi 值范围 0~639(50-32000)。
export const initDpiRange = (): number[] => {
  const dpiList: number[] = []
  for (let i = 50; i <= 32000; i += 50) {
    dpiList.push(i)
  }
  return dpiList
}

export const initDpiList = () => {
  return [800, 1200, 2000, 2400, 3000, 4000, 6000]
}

export const initDpiColor = () => {
  return [
    [242, 52, 52],
    [252, 168, 23],
    [247, 229, 0],
    [91, 225, 13],
    [15, 215, 246],
    [19, 118, 248],
    [194, 51, 255],
    [255, 112, 159],
    [103, 42, 246],
  ]
}

export const jingtaiV2LightAndSpeedRange = () => {
  let res = []
  for (let index = 0; index <= 100; index++) {
    res.push(index)
  }
  return res
}
